import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
import { DynamicAttachData } from '@/api/common/attach'
const apiUrl = `${urlPrefix}/UnitOwner`
//#region 基本信息
const GetUnitOwner = (id: number) => `${apiUrl}/${id}`
const ViewUnitOwner = (id: number) => `${apiUrl}/view/${id}`
const PostUnitOwner = `${apiUrl}`
const PutUnitOwner = (id: number) => `${apiUrl}/${id}`
//#endregion

export const emptyRspblty: UnitRspbltyData = {
    Id: 0,
    UserId: 0,
    DisplayName: '',
    Position: '',
    Email: '',
    CellPhone: '',

    ResponsibilityId: 0,
    ResponsibilityCode: '',
    ResponsibilityName: '',
    UpdateDate: new Date(),

    ListId: 0,
    UnitId: 0,
    UnitCode: '',
    UnitName: '',
}
export const emptyOwner: UnitOwnerData = {
    Id: 0,
    HeritageUnitId: 0,
    UnitOwner: '',
    OwnerPropertyId: 0,
    OwnerSuperior: '',
    OwnerIndustryId: 0,
    OwnerIndustry: '',
    HasManageOrg: false,
    ManageOrgName: '',
    ManageTel: '',
    IsUsed: false,
    UsageId: 0,
    UsageUnitName: '',
    AdminUnitName: '',
    IsOpen: false,
    AnnualTourists: 0,
    DayMaxTourists: 0,
    IsOtherTitle: false,
    NationalTitleId: 0,
    NationalOtherTitle: '',
    IsMinority: false,
    MinorityId: 0,

    UnitId: 0,
    OwnerPropertyName: '',
    OwnerIndustryName: '',
    UsageName: '',
    NationalTitleName: '',
    MinorityName: '',
    RspbltyList: [],
    DynamicAttachType: 0,
    DynamicAttachs: []
}
export interface UnitOwnerData {
    [key: string]: any
    Id: number
    HeritageUnitId: number
    UnitOwner: string
    OwnerPropertyId: number
    OwnerSuperior: string
    OwnerIndustryId: number
    OwnerIndustry: string
    HasManageOrg: boolean
    ManageOrgName: string
    ManageTel: string
    IsUsed: boolean
    UsageId: number
    UsageUnitName: string
    AdminUnitName: string
    IsOpen: boolean
    AnnualTourists: number
    DayMaxTourists: number
    IsOtherTitle: boolean
    NationalTitleId: number
    NationalOtherTitle: string
    IsMinority: boolean
    MinorityId: number

    UnitId: number
    OwnerPropertyName: string
    OwnerIndustryName: string
    UsageName: string
    NationalTitleName: string
    MinorityName: string
    RspbltyList: UnitRspbltyData[]
    DynamicAttachType: number
    DynamicAttachs: DynamicAttachData[]
}
export interface UnitRspbltyData {
    [key: string]: any
    Id: number
    UserId: number
    DisplayName: string
    Position: string
    Email: string
    CellPhone: string

    ResponsibilityId: number
    ResponsibilityCode: string
    ResponsibilityName: string
    UpdateDate: Date

    ListId: number
    UnitId: number
    UnitCode: string
    UnitName: string
}
export const getUnitOwner = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetUnitOwner(id),
    })
}
export const viewUnitOwner = (id: number) => {
    return tryAxios({
        method: 'get',
        url: ViewUnitOwner(id),
    })
}
export const postUnitOwner = (form: UnitOwnerData) => {
    return tryAxios({
        method: 'post',
        url: PostUnitOwner,
        data: form
    })
}
export const putUnitOwner = (id: number, form: UnitOwnerData) => {
    return tryAxios({
        method: 'put',
        url: PutUnitOwner(id),
        data: form
    })
}
